/* Earth Angel Frequencies: editorial blog article behaviour */
document.querySelectorAll('[data-eaf]').forEach(function (root) {
  var body = root.querySelector('[data-eaf-body]');
  if (!body) return;

  /* Sticky sidebar: if it is taller than the screen, let it scroll with the page
     until its bottom is visible, then stick (no inner scrollbar). */
  var side = root.querySelector('.eaf-side');
  if (side) {
    var setTop = function () {
      var base = parseInt(getComputedStyle(root).getPropertyValue('--eaf-sticky'), 10) || 24;
      var top = Math.min(base, window.innerHeight - side.offsetHeight - 24);
      side.style.top = top + 'px';
    };
    setTop();
    window.addEventListener('resize', setTop);
    window.addEventListener('load', setTop);
    if (window.ResizeObserver) new ResizeObserver(setTop).observe(side);
  }

  /* Older posts: only the post title may be an H1, so turn stray body H1s into H2s */
  body.querySelectorAll('h1').forEach(function (h) {
    var n = document.createElement('h2');
    n.innerHTML = h.innerHTML;
    if (h.id) n.id = h.id;
    h.parentNode.replaceChild(n, h);
  });

  /* Tables scroll sideways on small screens instead of breaking the layout */
  body.querySelectorAll('table').forEach(function (t) {
    if (t.parentNode.classList.contains('eaf-table')) return;
    var w = document.createElement('div');
    w.className = 'eaf-table';
    t.parentNode.insertBefore(w, t);
    w.appendChild(t);
  });

  /* Long quotes get a calmer style than short pull quotes */
  body.querySelectorAll('blockquote').forEach(function (q) {
    if (q.textContent.trim().length > 180) q.classList.add('eaf-bq-long');
  });

  /* Images: alt text ending in |left, |right or |wide controls placement */
  body.querySelectorAll('img').forEach(function (img) {
    var alt = img.getAttribute('alt') || '';
    var flag = img.getAttribute('data-eaf');
    var m = flag ? [null, flag] : alt.match(/\s*\|\s*(left|right|wide)\s*$/i);
    if (m) {
      img.classList.add('eaf-img-' + m[1].toLowerCase());
      img.setAttribute('alt', alt.replace(/\s*\|\s*(left|right|wide)\s*$/i, ''));
    } else if (img.style.cssFloat === 'left' || img.style.cssFloat === 'right') {
      img.classList.add('eaf-img-' + img.style.cssFloat);
    }
    img.style.cssFloat = '';
    img.removeAttribute('width');
    img.removeAttribute('height');
  });

  /* Video: wrap YouTube / Vimeo iframes in a responsive 16:9 frame */
  body.querySelectorAll('iframe').forEach(function (f) {
    if (/youtube|youtu\.be|vimeo/i.test(f.src || '') && !f.closest('.eaf-video')) {
      var w = document.createElement('div');
      w.className = 'eaf-video';
      f.parentNode.insertBefore(w, f);
      w.appendChild(f);
      f.removeAttribute('width');
      f.removeAttribute('height');
    }
    f.setAttribute('loading', 'lazy');
  });

  /* Audio: replace native player with a branded one */
  function fmt(s) {
    if (!isFinite(s)) return '0:00';
    var m = Math.floor(s / 60), x = Math.floor(s % 60);
    return m + ':' + (x < 10 ? '0' : '') + x;
  }
  var players = [];
  body.querySelectorAll('audio').forEach(function (a) {
    a.removeAttribute('controls');
    a.preload = 'metadata';
    var wrap = document.createElement('div');
    wrap.className = 'eaf-audio';
    wrap.innerHTML =
      '<button type="button" class="eaf-play" aria-label="Play"></button>' +
      '<div class="eaf-audio-main"><div class="eaf-audio-label">Listen</div>' +
      '<div class="eaf-audio-title"></div>' +
      '<div class="eaf-bar" role="slider" aria-label="Seek" tabindex="0"><span></span></div></div>' +
      '<div class="eaf-time">0:00</div>';
    wrap.querySelector('.eaf-audio-title').textContent = a.getAttribute('title') || a.getAttribute('data-title') || 'Audio';
    a.parentNode.insertBefore(wrap, a);
    wrap.appendChild(a);

    var btn = wrap.querySelector('.eaf-play');
    var bar = wrap.querySelector('.eaf-bar');
    var fill = bar.querySelector('span');
    var time = wrap.querySelector('.eaf-time');
    players.push(a);

    btn.addEventListener('click', function () {
      if (a.paused) {
        players.forEach(function (o) { if (o !== a) o.pause(); });
        a.play();
      } else {
        a.pause();
      }
    });
    a.addEventListener('play', function () { btn.classList.add('is-playing'); btn.setAttribute('aria-label', 'Pause'); });
    a.addEventListener('pause', function () { btn.classList.remove('is-playing'); btn.setAttribute('aria-label', 'Play'); });
    a.addEventListener('loadedmetadata', function () { time.textContent = '0:00 / ' + fmt(a.duration); });
    a.addEventListener('timeupdate', function () {
      var pct = a.duration ? (a.currentTime / a.duration) * 100 : 0;
      fill.style.width = pct + '%';
      time.textContent = fmt(a.currentTime) + ' / ' + fmt(a.duration);
    });
    bar.addEventListener('click', function (e) {
      var r = bar.getBoundingClientRect();
      if (a.duration) a.currentTime = ((e.clientX - r.left) / r.width) * a.duration;
    });
    bar.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') a.currentTime = Math.min(a.duration || 0, a.currentTime + 5);
      if (e.key === 'ArrowLeft') a.currentTime = Math.max(0, a.currentTime - 5);
    });
  });

  /* Headings: the top level a post actually uses (H2, H3 or H4) becomes the section style */
  var counts = { 2: 0, 3: 0, 4: 0 };
  body.querySelectorAll('h2, h3, h4').forEach(function (h) { counts[+h.tagName.charAt(1)]++; });
  var top = 0;
  [2, 3, 4].some(function (l) { if (counts[l] >= 2) { top = l; return true; } return false; });
  if (!top) [2, 3, 4].some(function (l) { if (counts[l] > 0) { top = l; return true; } return false; });
  var sub = top && top < 4 && counts[top + 1] > 0 ? top + 1 : 0;
  var heads = [];
  body.querySelectorAll('h2, h3, h4').forEach(function (h) {
    var l = +h.tagName.charAt(1);
    if (l === top) { h.classList.add('eaf-h-top'); heads.push(h); }
    else if (l === sub) { h.classList.add('eaf-h-sub'); heads.push(h); }
  });

  /* Table of contents */
  var toc = root.querySelector('[data-eaf-toc]');
  if (toc) {
    if (heads.length >= 2) {
      var list = toc.querySelector('ol');
      var used = {};
      heads.forEach(function (h) {
        var text = h.textContent.trim();
        if (!text) return;
        var id = h.id || text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'section';
        var base = id, n = 2;
        while (used[id] || (document.getElementById(id) && document.getElementById(id) !== h)) { id = base + '-' + n++; }
        used[id] = true;
        h.id = id;
        var li = document.createElement('li');
        if (h.classList.contains('eaf-h-sub')) li.className = 'eaf-sub';
        var a = document.createElement('a');
        a.href = '#' + id;
        a.textContent = text;
        li.appendChild(a);
        list.appendChild(li);
      });
      toc.hidden = false;
      if (window.matchMedia('(max-width: 860px)').matches) toc.removeAttribute('open');
    }
  }
});